import styled from 'styled-components';

export const CreateCourseBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const CreateCourseTitle = styled.p`
  min-width: 100px;
  margin-bottom: 0;
  font-size: 16px;
`;

export const GenerationModeBlock = styled.div`
  margin: 0 auto;
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
`;

export const GenerationModeLabel = styled.p`
  margin-right: 10px;
  width: 180px;
  font-size: 14px;
  margin-bottom: 0;
`;

export const ResultInfoBlock = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 50px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    padding: 0 160px 0 55px;
  }
  @media (max-width: 768px) {
    height: auto;
    padding: 20px 10px 60px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
  @media (max-width: 350px) {
    font-size: 20px;
  }
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
export const Label = styled.label`
  min-width: 150px;
  font-size: 20px;
  cursor: pointer;
  margin: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/CreateCourseModal/CreareCourseModalStyles.js